import { SET_DIALOG } from 'store/key';
import { produce } from 'utility/general';

const initialState = {
    confirmDialog: { result: null, title: '', description: '', isShow: false, isRequired: true },
    optionConfirmDialog: {
        result: null,
        title: '',
        description: '',
        isShow: false,
        isRequired: true,
        largeConfirm: false,
    },
    commentDialog: { result: null, title: '', description: '', isShow: false, isRequired: true, answer: null },
};

export const updateDialog = (data) => {
    return {
        type: SET_DIALOG,
        payload: { confirmDialog: data },
    };
};

export const updateCommentDialog = (data) => ({
    type: SET_DIALOG,
    payload: { commentDialog: data },
});

export const updateOptionConfirmDialog = (data) => ({
    type: SET_DIALOG,
    payload: { optionConfirmDialog: data },
});

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DIALOG:
            const newState = produce(state, (draft) => {
                // update nested object
                Object.entries(action.payload).forEach(([dialogType, dialogPayload]) => {
                    Object.entries(dialogPayload).forEach(([key, value]) => {
                        draft[dialogType][key] = value;
                    });

                    // draft[dialogType] = action.payload[dialogType];
                });
            });
            return newState;
        default:
            return state;
    }
};

export default reducer;
